import React, { Component } from 'react';
import TableRowCuentas from './TableRowCuentas';


class TableCuentas extends Component {

    constructor(props) {
        super(props);
    }

    createTable(cuentasVisa, cuentasOtras, tarjetas,permisoBaja, permisoModificacion) {
        
        //AGREGO A LAS CUENTAS LAS TARJETAS QUE LES CORRESPONDEN
        cuentasVisa.map(cuenta => cuenta.Tarjetas = [])
        cuentasOtras.map(cuenta => cuenta.Tarjetas = [])

        tarjetas.map(tarjeta => cuentasVisa.map(cuenta => { if (cuenta.CuentaTarjetaId == tarjeta.CuentaTarjetaId) cuenta.Tarjetas.push(tarjeta) }))
        tarjetas.map(tarjeta => cuentasOtras.map(cuenta => { if (cuenta.CuentaTarjetaId == tarjeta.CuentaTarjetaId) cuenta.Tarjetas.push(tarjeta) }))

        //SE DIVIDEN EN ARREGLOS SEPARADOS POR ADMINISTRADORA PARA GENERAR LAS CELDAS COMBINADAS DE ACUERDO A MARCA
        let visa = [];
        let cabal = [];
        let master = [];

        cuentasVisa.map(cuenta => visa.push(cuenta));
        cuentasOtras.map(cuenta => {
            if (cuenta.marcaId == 2) cabal.push(cuenta)
            if (cuenta.marcaId == 3) master.push(cuenta)
        });


        // SE LE ASIGNA UNA POSICION "CERO" A CADA ADMINISTRADORA Y EL LARGO DEL ARREGLO (CANTIDAD DE SOLICITUDES EN LA ADMINISTRADORA)
        // PARA PASARLE COMO PROPIEDAD AL COMPONENTE QUE VA A HACER LOS ROWSPAN DE ACUERDO A ADMINISTRADORA.
        if (visa.length > 0) visa.map((c, indice) => { c.primero = indice == 0; c.largo = visa.length })
        if (cabal.length > 0) cabal.map((c2, indice2) => { c2.primero = indice2 == 0; c2.largo = cabal.length })
        if (master.length > 0) master.map((c3, indice3) => { c3.primero = indice3 == 0; c3.largo = master.length })

        //SE VUELVEN A JUNTAR PARA PASAR UN SOLO ARREGLO
        let ambas = visa.concat(cabal)
        ambas = ambas.concat(master)
        
        return (
            ambas.map((cuenta) => {
                if (cuenta.primero) {
                    return <TableRowCuentas
                        key={cuenta.CuentaTarjetaId}
                        openPanelSeleccion={this.props.openPanelSeleccion}
                        eliminarCuenta={this.props.darDeBajaCuenta}
                        AbrirModuloConsultaOperacionCuenta={this.props.AbrirModuloConsultaOperacionCuenta}
                        seleccionarComponente={this.props.seleccionarComponente }
                        rowS={cuenta.largo}
                        cuenta={cuenta}
                        permisoBaja={permisoBaja} 
                        permisoModificacion={permisoModificacion}  
                        />
                } else {
                    return <TableRowCuentas
                        key={cuenta.CuentaTarjetaId}
                        openPanelSeleccion={this.props.openPanelSeleccion}
                        eliminarCuenta={this.props.darDeBajaCuenta}
                        AbrirModuloConsultaOperacionCuenta={this.props.AbrirModuloConsultaOperacionCuenta}
                        seleccionarComponente={this.props.seleccionarComponente }
                        rowS={""}
                        cuenta={cuenta}
                        permisoBaja={permisoBaja} 
                        permisoModificacion={permisoModificacion}  
                        />
                }
            })
        )
    }

    render() {
        const {permisoBaja, permisoModificacion} = this.props;
        let crearTabla = undefined;
        let me = this;
    
        if (this.props.cuentasVisa || this.props.cuentasOtras)
            crearTabla = me.createTable(this.props.cuentasVisa, this.props.cuentasOtras, this.props.tarjetas,permisoBaja, permisoModificacion)

        return (
            <div id={this.props.id} className={this.props.className}>
                <div className="row top-separator-xs">
                    <div className="col-md-12">
                        <div className='contenedor-titulo-cuentas'>
                            <h1>Cuentas del cliente</h1><br/>
                            {/* <button onClick={()=>this.props.redirectToAvisoViaje()} className='boton-aviso-viaje'><span>Aviso de Viaje</span><span className='icono-avion'></span></button> */}
                        </div>
                        <table className="table clickeable-row-table">
                            <thead>
                                <tr>
                                    <th className="rowBordersVistaClienteNoSides"></th>
                                    <th className="rowBordersVistaClienteNoSides"></th>
                                    <th className="rowBordersVistaClienteNoSides">CUENTA</th>
                                    <th className="rowBordersVistaClienteNoSides">TIPO</th>
                                    <th className="rowBordersVistaClienteNoSides">ESTADO</th>
                                    <th className="rowBordersVistaClienteNoSides">LÍMITE</th>
                                    <th className="rowBordersVistaClienteNoSides">SUCURSAL</th>
                                    <th className="rowBordersVistaClienteNoSides">INTEGR.</th>
                                    <th className="rowBordersVistaClienteNoSides">ACCIONES</th>
                                </tr>
                            </thead>
                            <tbody>
                                {crearTabla}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default TableCuentas;